import type { TRuleWithTheme } from '@ackee/fela';

export const container: TRuleWithTheme = () => ({
    paddingBottom: '2rem',

    desktop1200: {
        paddingBottom: '2rem',
    },
});
